if (!customElements.get('modal-dialog')) {
  class Modal extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('[data-modal-close]');
      this.content = this.querySelector('[data-modal-content]');
      this.overlay = this.querySelector('[data-modal-overlay]');
      this.isOpen = false;
      this.modalId = this.dataset?.id || null;
    }

    connectedCallback() {
      this.setupEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    setupEventListeners() {
      if (!this.modalId) return;

      // Internal close button
      this.closeButton?.addEventListener('click', () => this.close());

      // Overlay click
      this.overlay?.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });

      // External triggers
      document.querySelectorAll(`[data-modal-trigger="${this.modalId}"]`).forEach((trigger) => {
        trigger.setAttribute('aria-controls', `${this.modalId}-content`);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', () => this.open());
      });

      // Close on escape key
      document.addEventListener('keydown', this.handleEscKey.bind(this));
    }

    removeEventListeners() {
      if (!this.modalId) return;

      this.closeButton?.removeEventListener('click', () => this.close());
      this.overlay?.removeEventListener('click', () => this.close());
      document.removeEventListener('keydown', this.handleEscKey.bind(this));

      // Clean up external triggers
      document.querySelectorAll(`[data-modal-trigger="${this.modalId}"]`).forEach((trigger) => {
        trigger.removeEventListener('click', () => this.open());
      });
    }

    handleEscKey(e) {
      if (e.key === 'Escape' && this.isOpen) this.close();
    }

    open() {
      if (!this.modalId) return;

      this.isOpen = true;
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';

      // Update all trigger buttons
      document.querySelectorAll(`[data-modal-trigger="${this.modalId}"]`).forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'true');
      });

      // Trap focus within modal
      this.content?.setAttribute('tabindex', '0');
      this.content?.focus();

      // Trigger open event
      this.dispatchEvent(new CustomEvent('modal:opened'));
    }

    close() {
      if (!this.modalId) return;

      this.isOpen = false;
      this.removeAttribute('open');
      document.body.style.overflow = '';

      // Update all trigger buttons
      document.querySelectorAll(`[data-modal-trigger="${this.modalId}"]`).forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      // Remove focus trap
      this.content?.removeAttribute('tabindex');

      // Trigger close event
      this.dispatchEvent(new CustomEvent('modal:closed'));
    }
  }

  customElements.define('modal-dialog', Modal);
}
